import { useReducer, useEffect } from 'react';
import { ModalsManager } from '@bg-shared/contexts/ModalsManager/ModalsManager';

export const useUpdateOnModalsChange = (modalsManager: ModalsManager) => {
    const [, forceUpdate] = useReducer((x) => x + 1, 0);

    useEffect(() => modalsManager.subscribeOnModalsChange(forceUpdate), []);
};
